import { motion } from 'framer-motion';

import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ArticleOverlayRoot = superstyled({
  name: 'ArticleOverlay',
  slot: 'Root',
  tag: motion.div,
  styles: ({ theme }) => ({
    position: 'fixed',
    inset: 0,
    zIndex: 9999,
    backgroundColor: theme.palette.background.grey.main,
    overflowY: 'auto'
  })
});

export const ArticleOverlayContainer = superstyled({
  name: 'ArticleOverlay',
  slot: 'Container',
  tag: Box,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(3),
    marginInline: 'auto',
    maxWidth: '35rem',
    backgroundColor: theme.palette.background.grey.light,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(3)
  })
});

export const ArticleOverlaySummary = superstyled({
  name: 'ArticleOverlay',
  slot: 'Summary',
  tag: Text,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(3)
  })
});

export const ArticleOverlayTitle = superstyled({
  name: 'ArticleOverlay',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(3)
  })
});

export const Summary = superstyled({
  name: 'ArticleOverlay',
  slot: 'Summary',
  tag: Text,
  styles: ({ theme }) => ({
    textTransform: 'uppercase',
    paddingTop: theme.spacing(3)
  })
});

export const ArticleOverlayImage = superstyled({
  name: 'ArticleOverlay',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    height: 'auto'
  })
});

export const ArticleOverlayContent = superstyled({
  name: 'ArticleOverlay',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(3),
    '&& > * + *': {
      fontSize: '0.875rem',
      marginBlock: theme.spacing(2)
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1.5)
    },
    '& p': {
      marginBottom: theme.spacing(2)
    },
    '& span': {
      marginBottom: theme.spacing(2)
    },
    '& li': {
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5)
    },
    '& code': {
      backgroundColor: theme.palette.background.grey.light,
      padding: theme.spacing(0.25, 0.5),
      borderRadius: theme.shape.borderRadius,
      fontSize: '0.875rem'
    },
    '& pre': {
      backgroundColor: theme.palette.background.grey.light,
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      overflow: 'auto',
      marginBottom: theme.spacing(2)
    },
    '& blockquote': {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      marginLeft: 0,
      paddingLeft: theme.spacing(2),
      marginBottom: theme.spacing(2),
      fontStyle: 'italic'
    }
  })
});
